<template>
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">&times;</button>
    <h4 class="modal-title">{{ title }}</h4>
    <p class="mb0">{{description}}</p>
  </div>
</template>

<script>
export default {
  name: "modal-header",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
  },
};
</script>

<style>
.modal-header p {
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Modal/ModalHeader.vue